<template>
  <div class="bp-card reach">
    <card-title :title="title" />
    <div
      v-for="(card, idx) in cards"
      :key="idx"
      class="sub-card"
    >
      <img class="card-img" :src="idx === 0 ? iconTuanyou : iconGaode" :alt="title" />
      <div class="metrics">
        <div class="metric">
          <span class="label">总发送数(条)</span>
          <span class="num normal">{{ fmt(card.totalSend) }}</span>
        </div>
        <div class="metric">
          <span class="label">已发送数(条)</span>
          <span class="num" :class="idx % 2 === 0 ? 'red' : 'blue'">{{ fmt(card.sentSend) }}</span>
        </div>
        <div class="metric">
          <span class="label">待发送数(条)</span>
          <span class="num grey">{{ fmt(card.pendingSend) }}</span>
        </div>
        <div class="metric">
          <span class="label">曝光(人)</span>
          <span class="num normal">{{ fmt(card.exposure) }}</span>
        </div>
      </div>
      <!-- 发送进度条：已发送/总发送 -->
      <div class="progress">
        <div
          class="progress-fill"
          :class="idx % 2 === 0 ? 'red' : 'blue'"
          :style="{ width: pct(card) }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import CardTitle from './CardTitle'
import { fmtNum } from '../format'
import iconTuanyou from '../assets/icon-tuanyou.png'
import iconGaode from '../assets/icon-gaode.png'

export default {
  name: 'BpReachCard',
  components: { CardTitle },
  props: {
    // '短信' | 'PUSH'
    title: { type: String, default: '' },
    // [{ totalSend, sentSend, pendingSend, exposure }, ...]
    cards: { type: Array, default: () => [] }
  },
  data () {
    return { iconTuanyou, iconGaode }
  },
  methods: {
    fmt: fmtNum,
    // 进度条长度：已发送 / 总发送
    pct (card) {
      const t = Number(card.totalSend) || 0
      const s = Number(card.sentSend) || 0
      if (!t) return '0%'
      return Math.min(100, Math.round((s / t) * 100)) + '%'
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles.less';
.reach {
  .sub-card {
    position: relative;
    height: 120px;
    background: @bp-subcard-bg;
    border-radius: 16px;
    margin-top: 20px;
    padding: 22px 0 0 88px;
    box-sizing: border-box;
    overflow: hidden;
    .card-img {
      position: absolute;
      left: 16px;
      top: 20px;
      width: 48px;
      height: 48px;
      border-radius: 9.6px;
    }
    .metrics {
      display: flex;
      align-items: flex-start;
      .metric {
        display: flex;
        flex-direction: column;
        margin-right: 30px;
        .label {
          font-family: @font-cn;
          font-size: 16px;
          color: @bp-label;
          line-height: 1;
        }
        .num {
          margin-top: 8px;
          font-family: @font-num;
          font-weight: 700;
          font-size: 24px;
          line-height: 1;
          &.normal { color: @bp-num; }
          &.red { color: @bp-red; }
          &.blue { color: @bp-blue; }
          &.grey { color: @bp-grey-blue; }
        }
      }
    }
    .progress {
      position: absolute;
      left: 100px;
      right: 40px;
      bottom: 16px;
      height: 10px;
      background: #E4ECFF;
      border-radius: 5px;
      .progress-fill {
        height: 100%;
        border-radius: 5px;
        &.red { background: linear-gradient(90deg, #FFA8AA 0%, #FF455A 100%); }
        &.blue { background: linear-gradient(90deg, #78B1FF 0%, #378CFE 100%); }
      }
    }
  }
}
</style>
